import React, { useEffect, useState } from "react";
import "./UpgradePayment.scss";

import { FaCheck } from "react-icons/fa6";

import { FaLightbulb } from "react-icons/fa";
import { GiCrown } from "react-icons/gi";
import { MdOutlineWorkspacePremium } from "react-icons/md";

import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import ROUTES from "../../../constants/routes";
import PayPalButton from "../../../components/Paypal/Paypal";
import Loader from "../../../components/Loader/Loader";
import { useViewPortDetector } from "../../../helpers/viewPortDetector";

const UpgradePayment = ({ desktopView, selectedId, selectedPlanBilling }) => {
  const { currentViewPort, isReady } = useViewPortDetector();
  const navigate = useNavigate();
  const { subscription: currentSubscription } = useSelector(
    (state) => state.organizationReducer.value
  );
  const { plans: subsPlans, loading } = useSelector(
    (state) => state.subscriptionReducer.value
  );

  const { is_admin } = useSelector((state) => state.userReducer.value);
  const location = useLocation();

  const selected = desktopView
    ? selectedId || 0
    : location.state?.selected || 0;

  const selectedBillingTag = desktopView
    ? selectedPlanBilling || "monthly"
    : location.state?.selectedBilling || "monthly";

  const [subscriptionPackages, setSubscriptionPackages] = useState([]);

  const [selectedPackage, setSelectedPackage] = useState({});

  useEffect(() => {
    if (!is_admin) {
      navigate(ROUTES.upgrade.path);
      toast.dismiss(); toast.info(
        "You do not have sufficient permissions to perform this action. Please contact your administrator."
      );
    }
  }, [is_admin]);

  useEffect(() => {
    if (!desktopView && currentViewPort === "desktop" && isReady) {
      navigate(ROUTES.upgrade.path);
    }
  }, [desktopView, currentViewPort]);

  useEffect(() => {
    let tempPlans = subsPlans?.map((el, i) => {
      const array = el?.features?.length > 0 ? [...el?.features] : [];
      let lastThree =
        el?.pricing?.monthly?.price > 0 ? array.slice(-3) : array.slice(0, 3);

      if (el?.name === "Pro") {
        if (array.length >= 3) {
          const middleIndex = Math.floor(array.length / 2) - 1;
          lastThree = array.slice(middleIndex, middleIndex + 3);
        }
      }

      lastThree = lastThree?.map((el) => {
        return `${el?.name} ${el?.value ? `- ${el?.value}` : ""} ${
          el?.tag === "analytics" ? (el?.value ? "days" : "") : ""
        }`;
      });
      return {
        monthly_id: el?.pricing?.monthly?.id,
        yearly_id: el?.pricing?.yearly?.id,
        paypal_monthly_plan_id: el?.pricing?.monthly?.paypal_plan_id,
        paypal_yearly_plan_id: el?.pricing?.yearly?.paypal_plan_id,
        monthly_price: el?.pricing?.monthly?.price,
        yearly_price: el?.pricing?.yearly?.price,
        heading: el?.name,
        icon:
          el?.name === "Free" ? (
            <FaLightbulb />
          ) : el?.name === "Pro" ? (
            <GiCrown />
          ) : (
            <MdOutlineWorkspacePremium />
          ),
        desc: el?.description,
        color: el?.color,
        price: `$ ${el?.pricing?.monthly?.price}`,
        perMonth: (
          <>
            {`$ ${el?.pricing?.monthly?.price}`}
            <span>/mo</span>{" "}
          </>
        ),
        perYear: (
          <>
            {`$ ${el?.pricing?.yearly?.price}`}
            <span>/year</span>{" "}
          </>
        ),
        features: lastThree,
      };
    });

    let activePackage = selected
      ? tempPlans?.find((el) => el?.monthly_id === selected)
      : tempPlans?.length > 0
      ? tempPlans[0]
      : {};

    setSelectedPackage(activePackage);

    setSubscriptionPackages(tempPlans);
  }, [subsPlans]);

  const [selectedBilling, setSelectedBilling] = useState(selectedBillingTag);

  return (
    <>
      {loading && <Loader />}
      <div id="paypal-button-container" style={{ display: "none" }}></div>
      <div className="upgrade-payment">
        <div className="container-wrapper overall-content">
          <div className="select-plan">
            <p className="heading">
              {" "}
              <span>1</span> Select Plan
            </p>

            <div className="list">
              {subscriptionPackages.map((el, i) => {
                const isSelected = el === selectedPackage ? true : false;
                return (
                  <div
                    className={`item ${isSelected ? "active" : ""}`}
                    style={
                      isSelected
                        ? { border: `2px solid var(${selectedPackage?.color})` }
                        : {}
                    }
                    key={i}
                    onClick={() => {
                      setSelectedPackage(el);
                    }}
                  >
                    <div
                      className={`svg`}
                      style={{ backgroundColor: `var(${el?.color})` }}
                    >
                      <FaCheck />
                    </div>
                    <p
                      className="name"
                      style={{
                        backgroundColor: `var(${el?.color})`,
                      }}
                    >
                      {el?.heading}
                    </p>
                    <p className="desc">{el?.desc}</p>

                    <p className="price">{el?.perMonth}</p>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="choose-bill">
            <p className="heading">
              {" "}
              <span>2</span> Choose your billing
            </p>

            <div className="list">
              {selectedPackage?.monthly_id && (
                <div
                  className={`item ${
                    selectedBilling === "monthly" ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedBilling("monthly");
                  }}
                  style={
                    selectedBilling === "monthly"
                      ? { border: `2px solid var(${selectedPackage?.color})` }
                      : {}
                  }
                >
                  <div
                    className={`svg`}
                    style={
                      selectedBilling === "monthly"
                        ? {
                            backgroundColor: `var(${selectedPackage?.color})`,
                            border: `2px solid var(${selectedPackage?.color})`,
                          }
                        : {}
                    }
                  >
                    <FaCheck />
                  </div>
                  <p className="name">Monthly</p>
                  <p className="price">{selectedPackage?.perMonth}</p>
                </div>
              )}
              {selectedPackage?.yearly_id && (
                <div
                  className={`item ${
                    selectedBilling === "yearly" ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedBilling("yearly");
                  }}
                  style={
                    selectedBilling === "yearly"
                      ? { border: `2px solid var(${selectedPackage?.color})` }
                      : {}
                  }
                >
                  <div
                    className={`svg`}
                    style={
                      selectedBilling === "yearly"
                        ? {
                            backgroundColor: `var(${selectedPackage?.color})`,
                            border: `2px solid var(${selectedPackage?.color})`,
                          }
                        : {}
                    }
                  >
                    <FaCheck />
                  </div>
                  <p className="name">Yearly</p>
                  <p className="price">{selectedPackage?.perYear}</p>
                </div>
              )}
            </div>
            {/* <img src="/images/paypal.png" alt="" aria-label="PayPal" /> */}
          </div>
          {/* <div className="buttons">
            <button
              className="paypal"
              onClick={() => {
                handleCustomPayment("PayPal");
              }}
            >
              <img src="/images/paypal.png" alt="" aria-label="PayPal" />
            </button>
            <button
              onClick={() => {
                handleCustomPayment("Debit/Credit Card");
              }}
            >
              <FaRegCreditCard /> Debit or Credit Card
            </button>
          </div> */}
          {selectedPackage && (
            <div
              className="plan-container"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
            >
              {selectedPackage?.paypal_monthly_plan_id &&
                selectedBilling === "monthly" && (
                  <div className="buttons">
                    <PayPalButton
                      planId={selectedPackage.paypal_monthly_plan_id}
                    />
                  </div>
                )}

              {selectedPackage?.paypal_yearly_plan_id &&
                selectedBilling === "yearly" && (
                  <div className="buttons">
                    <PayPalButton
                      planId={selectedPackage.paypal_yearly_plan_id}
                    />
                  </div>
                )}
            </div>
          )}
        </div>

        {/* <ConfirmModel
          selectedPaymentMethod={selectedPaymentMethod}
          setSelectedPaymentMethod={setSelectedPaymentMethod}
          currentSubscription={currentSubscription}
          selectedBilling={selectedBilling}
          selectedPackage={selectedPackage}
        />

        {selectedPaymentMethod && (
          <div
            className="back"
            onClick={() => {
              setSelectedPaymentMethod("");
            }}
          ></div>
        )} */}
      </div>
    </>
  );
};

export default UpgradePayment;

// const ConfirmModel = ({
//   selectedPaymentMethod,
//   setSelectedPaymentMethod,
//   currentSubscription,
//   selectedPackage,
//   selectedBilling,
// }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { id: organization_id } = useSelector(
//     (state) => state.organizationReducer.value
//   );
//   const [submitting, setSubmitting] = useState(false);

//   const handleSubscribe = () => {
//     console.log(selectedPackage);

//     if (
//       (selectedBilling === "monthly" && selectedPackage?.monthly_price > 0) ||
//       (selectedBilling === "yearly" && selectedPackage?.yearly_price > 0)
//     ) {
//       setSubmitting(false);
//       const data = {
//         plan_id:
//           selectedBilling === "monthly"
//             ? selectedPackage?.monthly_id
//             : selectedBilling === "yearly"
//             ? selectedPackage?.yearly_id
//             : null,
//         payment_method: selectedPaymentMethod,
//         amount:
//           selectedBilling === "monthly"
//             ? selectedPackage?.monthly_price
//             : selectedBilling === "yearly"
//             ? selectedPackage?.yearly_price
//             : 0,
//       };

//       subscribeToPlan(organization_id, data)
//         .then((res) => {
//           if (res.data?.status) {
//             const organizationSubscription = res.data?.subscription;
//             dispatch(
//               updateOrganizationSubscription({
//                 subscription: organizationSubscription,
//               })
//             );
//             toast.dismiss(); toast.success(
//               "Congrats, Your organization is successfully subscribed to this plan."
//             );
//             navigate(ROUTES.home.path);
//           } else {
//             toast.dismiss(); toast.error("Error while subscribing to the plan.");
//           }
//         })
//         .catch((err) => {
//           if (err?.response?.data?.message) {
//             if (err?.response?.data?.message === "User not authorized!") {
//               toast.dismiss(); toast.error(
//                 "You do not have sufficient permissions to perform this action. Please contact your administrator."
//               );
//             } else {
//               toast.dismiss(); toast.error(`${err?.response?.data?.message}`);
//             }
//           } else {
//             toast.dismiss(); toast.error("Error while subscribing to the plan.");
//           }
//         })
//         .finally(() => {
//           setSubmitting(false);
//         });
//     } else {
//       toast.dismiss(); toast.info("You have selected a free plan!");
//     }
//   };

//   const handleUnsubscribe = () => {
//     if (currentSubscription?.plan?.price > 0) {
//       setSubmitting(false);

//       unSubscribeToPlan(organization_id)
//         .then((res) => {
//           if (res.data) {
//             const organizationSubscription = res.data;
//             dispatch(
//               updateOrganizationSubscription({
//                 subscription: organizationSubscription,
//               })
//             );
//             toast.dismiss(); toast.success(
//               "Your organization is successfully unsubscribed from the plan."
//             );
//             navigate(ROUTES.home.path);
//           } else {
//             toast.dismiss(); toast.error("Error while unsubscribing to the plan.");
//           }
//         })
//         .catch((err) => {
//           if (err?.response?.data?.message) {
//             if (err?.response?.data?.message === "User not authorized!") {
//               toast.dismiss(); toast.error(
//                 "You do not have sufficient permissions to perform this action. Please contact your administrator."
//               );
//             } else {
//               toast.dismiss(); toast.error(`${err?.response?.data?.message}`);
//             }
//           } else {
//             toast.dismiss(); toast.error("Error while unsubscribing to the plan.");
//           }
//         })
//         .finally(() => {
//           setSubmitting(false);
//         });
//     } else {
//       toast.dismiss(); toast.info("Your organization is subscribed to a free plan!");
//     }
//   };

//   return (
//     <div className={`confirm-model ${selectedPaymentMethod ? "active" : ""}`}>
//       <h1>
//         {currentSubscription?.plan?.price > 0 ? "Unsubscribe" : "Subscribe"}{" "}
//         Demo
//       </h1>

//       <p>
//         Are you sure you want to{" "}
//         {currentSubscription?.plan?.price > 0 ? "unsubscribe" : "subscribe"} to
//         this plan ?
//       </p>
//       <div className="buttons">
//         <CustomButton
//           name={"Cancel"}
//           color={"danger"}
//           type={"button"}
//           handleSubmit={() => {
//             setSelectedPaymentMethod("");
//           }}
//           disabled={submitting}
//         />
//         <CustomButton
//           name={
//             currentSubscription?.plan?.price > 0 ? "Unsubscribe" : "Subscribe"
//           }
//           color={"primary"}
//           type={"button"}
//           handleSubmit={() => {
//             if (currentSubscription?.plan?.price > 0) {
//               handleUnsubscribe();
//             } else {
//               handleSubscribe();
//             }
//           }}
//           disabled={submitting}
//         />
//       </div>
//     </div>
//   );
// };
